import React from 'react';

const Shimmer: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

const DashboardSkeleton: React.FC = () => (
  <div className="space-y-6">
    <div className="flex items-center gap-4">
      <Shimmer className="h-12 w-12 rounded-full" />
      <div className="space-y-2 flex-1">
        <Shimmer className="h-5 w-48" />
        <Shimmer className="h-3 w-32" />
      </div>
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <Shimmer className="h-40 rounded-lg" />
      <Shimmer className="h-40 rounded-lg" />
    </div>
    <Shimmer className="h-32 rounded-lg" />
    <Shimmer className="h-48 rounded-lg" />
  </div>
);

const CardSkeleton: React.FC = () => (
  <div className="space-y-3 animate-pulse">
    <Shimmer className="h-4 w-3/4" />
    <Shimmer className="h-3 w-1/2" />
    <Shimmer className="h-3 w-2/3" />
  </div>
);

const GallerySkeleton: React.FC = () => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
    {Array.from({ length: 8 }).map((_, i) => (
      <div key={i} className="animate-pulse">
        <Shimmer className="h-36 rounded-t-lg" />
        <div className="p-3 space-y-2">
          <Shimmer className="h-4 w-16" />
          <Shimmer className="h-3 w-12" />
        </div>
      </div>
    ))}
  </div>
);

export { Shimmer, DashboardSkeleton, CardSkeleton, GallerySkeleton };
